import { Stack, Typography } from '@mui/material'
import { formatPriceDemical } from 'Helpers/GlobalHelpers'

const GenealogyColumn = ({ title, dataKey, data, withBorder = false, withRightBorder = false, flex }) => {
    const borderStyle = {
        ...(withBorder && {
            borderLeft: '1px solid #D1D9E2',
            borderRight: '1px solid #D1D9E2'
        }),
        ...(withRightBorder && {
            borderRight: '1px solid #D1D9E2'
        })
    }

    return (
        <Stack sx={{ flex }}>
            <Stack
                sx={{
                    paddingY: '15px',
                    borderBottom: '1px solid #D1D9E2',
                    height: '50px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minWidth: '50px',
                    padding: '15px 12px',
                    ...borderStyle
                }}>
                <Typography variant="h4" fontFamily={'Inter'} color="#384250" fontWeight={400} fontSize={'16px'}>
                    {title}
                </Typography>
            </Stack>
            {data &&
                data.map((item, index) => {
                    const bgColor = index % 2 === 0 ? '#F5F5F5' : '#FFFFFF'
                    return (
                        <Stack
                            key={`${title}-${index}`}
                            sx={{
                                paddingY: '15px',
                                borderBottom: '1px solid #D1D9E2',
                                minHeight: '63px',
                                justifyContent: 'center',
                                alignItems: 'center',
                                minWidth: '50px',
                                padding: '15px 12px',
                                backgroundColor: bgColor,
                                ...borderStyle
                            }}>
                            <Typography variant="h4" fontFamily={'Inter'} color="#384250" fontWeight={400} fontSize={'16px'}>
                                {formatPriceDemical(item[dataKey])}
                            </Typography>
                        </Stack>
                    )
                })}
        </Stack>
    )
}

export default GenealogyColumn
